import { c as _c } from "react/compiler-runtime";
import { IcoWarning16 } from '@onefootprint/icons';
import type { DocumentImageError } from '@onefootprint/request-types/dashboard';
import { useRef } from 'react';
import type { Rotation } from '@/utils/rotation';
import BaseImage from './components/base-image';
import RotatedImage from './components/rotated-image';
import useFailureReasonText from './hooks/use-failure-reason-text';
type UploadImageProps = {
  objectUrl: string;
  alt: string;
  failureReasons: DocumentImageError[];
  rotateIndex?: number;
  rotation?: Rotation;
};
export const UploadImage = t0 => {
  const $ = _c(21);
  const {
    objectUrl,
    alt,
    failureReasons,
    rotateIndex,
    rotation
  } = t0;
  const failureReasonT = useFailureReasonText();
  const ref = useRef(null);
  if (typeof rotateIndex === "number") {
    let t1;
    if ($[0] !== alt || $[1] !== objectUrl || $[2] !== rotateIndex) {
      t1 = <RotatedImage alt={alt} src={objectUrl} rotateIndex={rotateIndex} />;
      $[0] = alt;
      $[1] = objectUrl;
      $[2] = rotateIndex;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (failureReasons.length > 0) {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoWarning16 color="error" />;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== failureReasonT || $[6] !== failureReasons[0]) {
      t2 = failureReasonT(failureReasons[0]);
      $[5] = failureReasonT;
      $[6] = failureReasons[0];
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== t2) {
      t3 = <div className="flex items-center w-full gap-2 px-3 py-2 border rounded text-label-2 text-error bg-error border-tertiary">{t1}{t2}</div>;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== alt || $[11] !== objectUrl || $[12] !== rotation) {
      t4 = <BaseImage alt={alt} src={objectUrl} ref={ref} rotation={rotation} />;
      $[10] = alt;
      $[11] = objectUrl;
      $[12] = rotation;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== t3 || $[15] !== t4) {
      t5 = <div className="relative flex flex-col items-center justify-center gap-2 w-full">{t3}{t4}</div>;
      $[14] = t3;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t1;
  if ($[17] !== alt || $[18] !== objectUrl || $[19] !== rotation) {
    t1 = <BaseImage alt={alt} src={objectUrl} rotation={rotation} />;
    $[17] = alt;
    $[18] = objectUrl;
    $[19] = rotation;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  return t1;
};
export default UploadImage;